import * as d3 from 'd3'

const formatMillisecond = d3.timeFormat('%L ms')
const formatSecond = d3.timeFormat('%S.%L s')
const formatMinute = d3.timeFormat('%H:%M')
const formatHour = d3.timeFormat('%H:%M')
const formatDay = d3.timeFormat('%d. %b')

// Define filter conditions
export default (date: Date): string =>
    (d3.timeSecond(date) < date
        ? formatMillisecond
        : d3.timeMinute(date) < date
        ? formatSecond
        : d3.timeHour(date) < date
        ? formatMinute
        : d3.timeDay(date) < date
        ? formatHour
        : formatDay)(date)
